import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLang } from '../i18n';
import {
  getAnalyticsConsent,
  loadAnalytics,
  setAnalyticsConsent,
  trackPageView,
} from '../analytics';
import './AnalyticsConsent.css';

const COPY = {
  fr: {
    kicker: 'Statistiques du site',
    title: 'Accepter les statistiques de visite ?',
    text: 'Elles m’aident à comprendre comment le site est utilisé et à l’améliorer. Vous pouvez accepter ou refuser, puis modifier votre choix à tout moment.',
    accept: 'Accepter',
    refuse: 'Refuser',
    privacy: 'En savoir plus',
  },
  en: {
    kicker: 'Site statistics',
    title: 'Allow visit statistics?',
    text: 'They help me understand how the site is used and improve it. You can accept or refuse, then change your choice at any time.',
    accept: 'Accept',
    refuse: 'Refuse',
    privacy: 'Learn more',
  },
  pt: {
    kicker: 'Estatísticas do site',
    title: 'Aceitar estatísticas de visita?',
    text: 'Elas me ajudam a entender como o site é usado e a melhorá-lo. Você pode aceitar ou recusar e alterar sua escolha a qualquer momento.',
    accept: 'Aceitar',
    refuse: 'Recusar',
    privacy: 'Saiba mais',
  },
};

export default function AnalyticsConsent() {
  const { lang } = useLang();
  const location = useLocation();
  const t = COPY[lang] || COPY.fr;
  const [choice, setChoice] = useState(() => getAnalyticsConsent());
  const [open, setOpen] = useState(() => getAnalyticsConsent() === null);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    const onChange = (event) => setChoice(event.detail);
    window.addEventListener('analytics-consent-open', onOpen);
    window.addEventListener('analytics-consent-changed', onChange);
    return () => {
      window.removeEventListener('analytics-consent-open', onOpen);
      window.removeEventListener('analytics-consent-changed', onChange);
    };
  }, []);

  useEffect(() => {
    if (choice !== 'accepted') return;
    if (!loadAnalytics()) return;
    const timer = window.setTimeout(() => {
      trackPageView(location.pathname + location.search + location.hash);
    }, 50);
    return () => window.clearTimeout(timer);
  }, [choice, location.pathname, location.search, location.hash]);

  const choose = (value) => {
    setAnalyticsConsent(value);
    setChoice(value);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <aside className="analytics-consent" role="dialog" aria-live="polite" aria-label={t.kicker}>
      <div className="analytics-consent-copy">
        <span>{t.kicker}</span>
        <strong>{t.title}</strong>
        <p>{t.text}</p>
        <a href="/politique-confidentialite">{t.privacy} ↗</a>
      </div>
      <div className="analytics-consent-actions">
        <button type="button" className="consent-accept" onClick={() => choose('accepted')}>{t.accept}</button>
        <button type="button" className="consent-refuse" onClick={() => choose('refused')}>{t.refuse}</button>
      </div>
    </aside>
  );
}
